import HTTP from "../../../services/HTTP.js";

export const fetchCountries = async () => {
  const response = await HTTP.get("/location/countries");
  return response.data;
};

export const fetchStates = async (countryCode) => {
  const response = await HTTP.get(`/location/states/${countryCode}`);
  return response.data;
};

export const fetchCities = async (countryCode, stateCode) => {
  const response = await HTTP.get(
    `/location/cities/${countryCode}/${stateCode}`
  );
  return response.data;
};
